import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import BannerItem from "../../component/BannerItem/BannerItem";
import useWindowDimensions from "../../useWindowDimensions";
import banner from "../../images/banner.png";
import create from "../../images/homepage1/create.png";

import dispute from "../../images/homepage1/dispute.png";
import transit from "../../images/homepage1/transit.png";
import career from "../../images/homepage1/career.png";
import program from "../../images/homepage1/program.png";
import integration from "../../images/homepage1/integration.png";
import business from "../../images/homepage1/business.png";
import "./style.less";
import { Col, model, Row } from "antd";
import "swiper/swiper-bundle.css";
import prevarrow from "../../images/homepage/leftarrow.svg";
import nextarrow from "../../images/homepage/rightarrow.svg";
import vector from "../../images/homepage1/vector.svg";
import trackOrderImg from "../../images/homepage1/trackOrderImg.svg";
import packageDelivery from "../../images/homepage1/packageDelivery.svg";
import blueTick from "../../images/homepage1/blueTick.svg";
import whyUsBanner from "../../images/homepage1/whyUsBanner.png";
import home1 from "../../images/homepage1/home1.png";
import home2 from "../../images/homepage1/home2.png";
import WOW from "wowjs";
import moment from "moment/moment";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  Thumbs,
  EffectFade,
} from "swiper";
import Button from "../../component/Button/Button";
import RatingContainer from "../../component/RatingContainer/RatingContainer";
import axios from "axios";
import AddressAutocomplete from "../../component/AddressAutocomplete/AddressAutocomplete";
import Autocomplete from "react-google-autocomplete";

import fbscan from "../../images/homepage/fbscan.png";
import whatsappscan from "../../images/homepage/whatsappscan.png";
import youtubescan from "../../images/homepage/youtubescan.png";

import { Modal } from "react-bootstrap";
import InputText from "../../component/InputText/InputText";
import urldata, { Imageurldata } from "../../urldata";
import FooterContactUsItem from "../../component/FooterContactUsItem/FooterContactUsItem";
import Cookies from "js-cookie";
const data = [
  { carrier: "Anom", transit: 19, tag: "Male", cost: "5000/-", action: "" },
  { carrier: "Anom", transit: 19, tag: "Male", cost: "5000/-", action: "" },
  { carrier: "Anom", transit: 19, tag: "Male", cost: "5000/-", action: "" },
  { carrier: "Anom", transit: 19, tag: "Male", cost: "5000/-", action: "" },
];

// const bannerArr = [{}, {}, {}, {}, {}]

function formatText(text = "") {
  // Split the text by underscores
  const words = text.split("_");

  // Capitalize the first letter of each word and join them with a space
  const formattedText = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return formattedText;
}

const apiKey = "AIzaSyCHXfEvF8wJ9Ig2ztnAPHPactI_-ap29sc";
const mapApiJs = "https://maps.googleapis.com/maps/api/js";

function loadAsyncScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    Object.assign(script, {
      type: "text/javascript",
      async: true,
      src,
    });
    script.addEventListener("load", () => resolve(script));
    document.head.appendChild(script);
  });
}

const extractAddress = (place) => {
  const address = {
    city: "",
    state: "",
    zip: "",
    country: "",
    plain() {
      const city = this.city ? this.city + ", " : "";
      const zip = this.zip ? this.zip + ", " : "";
      const state = this.state ? this.state + ", " : "";
      return city + zip + state + this.country;
    },
  };

  if (!Array.isArray(place?.address_components)) {
    return address;
  }
  if (place.place_id) {
    address.placeId = place.place_id; // Set placeId if available
  }

  place.address_components.forEach((component) => {
    const types = component.types;
    const value = component.long_name;

    if (types.includes("locality")) {
      address.city = value;
    }

    if (types.includes("administrative_area_level_2")) {
      address.state = value;
    }

    if (types.includes("postal_code")) {
      address.pincode = value;
    }

    if (types.includes("country")) {
      address.country = value;
    }
  });

  return address;
};

const fetchPlaceDetails = async (placeId) => {
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&key=AIzaSyCHXfEvF8wJ9Ig2ztnAPHPactI_-ap29sc`
  );

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  const data = await response.json();
  const result = data.result;

  const addressComponents = result.address_components || [];

  let country = "";
  let state = "";
  let city = "";

  for (const component of addressComponents) {
    if (component.types.includes("country")) {
      country = component.long_name;
    } else if (component.types.includes("administrative_area_level_1")) {
      state = component.long_name;
    } else if (component.types.includes("locality")) {
      city = component.long_name;
    }
  }

  return { country, state, city };
};

const Homepage = (props) => {
  const { t } = useTranslation();
  const { height, width } = useWindowDimensions();
  const [trackerOrderNo, settrackerOrder] = useState("");
  const [trackerOrderData, setTrackerOrderData] = useState("");
  const [orderData, setOrderData] = useState();
  const [bannerArr, setBannerArr] = useState([]);

  const [descShow, setDescShow] = useState(true);

  const [weight, setWeight] = useState("");

  const [unit, setUnit] = useState("kg");

  const sourceInput = useRef(null); // Reference for the source input field
  const destInput = useRef(null); // Reference for the destination input field
  const [sourceAddress, setSourceAddress] = useState({}); // State for source address
  const [destAddress, setDestAddress] = useState({}); // State for destination address

  const [reviewName, setName] = useState("");
  const [feedbackTxt, setFeedbackText] = useState("");
  const [rating, setRating] = useState(5);

  const [feedbackErr, setFeedbackErr] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);

  const [ratingList, setRatingList] = useState([]);
  const history = useHistory();

  const getData = async () => {
    try {
      const data = await axios.get(urldata + "user/getHomePageData");

      const banerData = data.data.data.bannerData.map((item) => {
        return {
          imgUrl: Imageurldata + item.imgUrl,
          mbimgUrl: Imageurldata + item.mbimgUrl,
        };
      });

      setBannerArr(banerData);

      setRatingList(data.data.data.ratingData);

      setLoading(false);
    } catch (error) {
      setBannerArr([
        { imgUrl: banner, mbimgUrl: banner },
        { imgUrl: banner, mbimgUrl: banner },
      ]);
      setRatingList([]);
      setLoading(false);
    }
    const swiper = new Swiper(".homesec1-swiper", {
      slidesPerView: 1,
      autoplay: {
        delay: 8000,
      },
      spaceBetween: 0,
      navigation: {
        nextEl: ".homesec1 .swiper-button-next",
        prevEl: ".homesec1 .swiper-button-prev",
      },
      pagination: {
        el: ".homesec1 .swiper-pagination",
        clickable: true,
      },
    });

    const swiper2 = new Swiper(".homepage_sec8-swiper", {
      slidesPerView: width > 1023 ? 3 : 1,
      spaceBetween: 30,
      autoplay: {
        delay: 8000,
      },
      navigation: {
        nextEl: ".homepage_sec8 .swiper-button-next",
        prevEl: ".homepage_sec8 .swiper-button-prev",
      },
      pagination: {
        el: ".homepage_sec8 .swiper-pagination",
        clickable: true,
      },
    });
    initMapScript().then(() => initAutocomplete());
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const handleBookNowBtnClick = () => {
    const isDashboardLogin = localStorage.getItem("isDashboardLogin");
    if (isDashboardLogin === "true" && Cookies.get("sb_token")) {
      // window.location.href = "https://wyngs.speedboxapp.com/placeorder";
      window.location.href =
        "https://wyngs-my.speedboxapp.com/shipment/create-single";
    } else {
      window.location.href = "https://wyngs-my.com/login";
    }
  };

  const handleReviewBtnClick = async () => {
    let formIsValid = true;

    if (!reviewName) {
      formIsValid = false;
      setFeedbackErr("*Please enter your Name.");
      return;
    }
    if (!feedbackTxt) {
      formIsValid = false;
      setFeedbackErr("*Please enter your Feedback message.");
      return;
    }

    if (formIsValid) {
      setFeedbackErr("");
      try {
        const data = await axios.post(urldata + "user/addRating", {
          name: reviewName,
          feedback: feedbackTxt,
          rating,
        });
        setName("");
        setFeedbackText("");
        setShow(false);
      } catch (error) {
        alert(error?.response?.data?.msg || "Something went wrong");
      }
    }
  };

  const handleOnChangeRating = (e) => {
    setRating(e.target.value);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };

  const initMapScript = () => {
    if (window.google) {
      return Promise.resolve();
    }
    const src = `${mapApiJs}?key=${apiKey}&libraries=places&v=weekly`;
    return loadAsyncScript(src);
  };

  const onChangeAddress = (autocomplete, setAddressCallback) => {
    const place = autocomplete.getPlace();
    setAddressCallback({ ...extractAddress(place) });
  };

  const initAutocomplete = () => {
    if (sourceInput.current) {
      const sourceAutocomplete = new window.google.maps.places.Autocomplete(
        sourceInput.current
      );
      sourceAutocomplete.setFields(["address_component", "geometry"]);
      sourceAutocomplete.addListener("place_changed", () =>
        onChangeAddress(sourceAutocomplete, setSourceAddress)
      );
    }

    if (destInput.current) {
      const destAutocomplete = new window.google.maps.places.Autocomplete(
        destInput.current
      );
      destAutocomplete.setFields(["address_component", "geometry"]);
      destAutocomplete.addListener("place_changed", () =>
        onChangeAddress(destAutocomplete, setDestAddress)
      );
    }
  };

  useEffect(() => {}, []);

  const handleDescClose = () => setDescShow(false);

  const handleUnitChange = (event) => {
    setUnit(event.target.value);
  };

  useEffect(() => {
    window.scroll(0, 0);
    document.title = "Wyngs - Home Page";
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const sliderBannerList = bannerArr.map((item, i) => (
    <div key={i} className="swiper-slide">
      <img className="fluid bannerImg" src={item.imgUrl} />

      <>
        <div className="textContainer">
          <div className="d-f firstContainer">
            <div>
              <img src={vector} className="fluid" />
            </div>
            <div className="weProvide">{t("homepage.bannerHeading")}</div>
            <br></br>
            {item.text2} <br></br> {item.text3}
          </div>
          <div className="titleConatiner">
            <div className="title">{t("homepage.bannerDesc")}</div>
          </div>

          <div className="btnContainer">
            <Button
              orange="orange"
              onClick={() =>
                (window.location.href = `${process.env.REACT_APP_DOMAIN}/service`)
              }
              title={t("Our services")}
            />
          </div>
        </div>
      </>
    </div>
  ));

  const mobileSliderList = bannerArr.map((item, i) => (
    <div key={i} className="swiper-slide">
      <img className="fluid" src={item.mbimgUrl} />
      <>
        <div className="textContainer">
          <div className="d-f firstContainer">
            <div>
              <img src={vector} className="fluid" />
            </div>
            <div className="weProvide">{t("homepage.bannerHeading")}</div>
            <br></br>
            {item.text2} <br></br> {item.text3}
          </div>
          <div className="titleConatiner">
            <div className="title">{t("homepage.bannerDesc")}</div>
          </div>

          <div className="btnContainer">
            <Button
              onClick={() =>
                (window.location.href = `${process.env.REACT_APP_DOMAIN}/service`)
              }
              title={t("Our services")}
            />
          </div>
        </div>
      </>
    </div>
  ));

  const reviewSlider = ratingList.map((item, i) => (
    <div key={i} className="swiper-slide">
      <div className="box d-f">
        <div className="imgContainer">
          <img className="fluid" src={blueTick} />
        </div>
        <div className="secondContainer">
          <div className="text-box">
            <div className="t2">{item.name}</div>
            <div className="t1">{item.feedback}</div>
          </div>
          <div className="rating">
            <RatingContainer fixedRating={item.rating} />
          </div>
        </div>
      </div>
    </div>
  ));

  const trackOrderBtnClick = async () => {
    if (trackerOrderNo.length < 5) {
      alert("Please enter track order number");
    } else {
      try {
        const data = await axios.get(
          // "https://wyngs.speedboxapp.com/speedbox/api/v1/trackShipment",
          // "https://wyngs-my.speedboxapp.com/prod/api/v2/tracking/track/single",
          // { orderNumber: [trackerOrderNo] },
          "https://wyngs-my.speedboxapp.com/prod/api/v2/tracking/track/single",

          {
            params: {
              shipmentNumber: trackerOrderNo,
            },
            // headers: {
            //   Authorization:
            //     "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NGVlZjRlNzU4MWJmMzAwMDhhYTVhYmYiLCJfc2lkIjoiZGU5YzAxYTAtNTBiNi0xMWVlLThlZDAtYTFkOTgxMzRhM2I4IiwibG9nZ2VkSW5UaW1lIjoiMjAyMy0wOS0xMVQxNToyMToyNS4xMjFaIiwiaWF0IjoxNjk0NDQ1Njg1fQ.J98OX8rADdUA_yDhq-F-op4zFgNJE8lOnyYzeK0jVi8",
            // },
          }
        );
        setTrackerOrderData(data.data.data[0]);
      } catch (error) {
        alert(error?.response?.data?.msg || "Something went wrong");
      }
    }
  };

  const handleGetRateBtnClick = async () => {
    if (!sourceAddress?.hasOwnProperty("country")) {
      alert("Please select pickup location");
    } else if (!destAddress?.hasOwnProperty("country")) {
      alert("Please select destination location");
    } else if (!sourceAddress?.hasOwnProperty("pincode")) {
      alert("Please Pickup pincode");
    } else if (!destAddress?.hasOwnProperty("pincode")) {
      alert("Please Destination pincode");
    } else if (weight === "") {
      alert("Please enter weight");
    } else {
      let wtInKg = weight;
      if (unit === "lbs") {
        wtInKg = parseFloat(wtInKg) * 0.453592;
      }
      try {
        const data = await axios.post(urldata + "user/getRates", {
          source: sourceAddress,
          destination: destAddress,
          weight: wtInKg,
        });

        setOrderData(data.data.data);
      } catch (error) {
        alert(error?.response?.data?.error || "Something went wrong");
      }
    }
  };

  return (
    <div>
      <section className="homesec1 wow fadeIn">
        {width >= 640 ? (
          <>
            <div className="homesec1-swiper swiper-container">
              <div className="swiper-wrapper">{sliderBannerList}</div>
            </div>
            <img src={prevarrow} className="swiper-button-prev" />
            <img src={nextarrow} className="swiper-button-next" />
            {/* <img
							onClick={scrollToDiv}
							src={scrollIcon}
							className='scrollicon'
						/> */}
          </>
        ) : (
          <>
            <div className="homesec1-swiper swiper-container">
              <div className="swiper-wrapper">{mobileSliderList}</div>
            </div>
          </>
        )}
      </section>

      <section className="homesec2 wow fadeIn">
        <div className="titleContainer d-f j-c a-c">
          <div className="imgContainer">
            <img src={trackOrderImg} className="fluid"></img>
          </div>
          <div className="title">Track your order</div>
        </div>
        <div className="d-f trackInputBoxContainer">
          <div className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M8.63633 2.5C7.42268 2.5 6.23628 2.85989 5.22717 3.53416C4.21806 4.20843 3.43155 5.16679 2.9671 6.28806C2.50266 7.40932 2.38114 8.64314 2.61791 9.83347C2.85468 11.0238 3.43911 12.1172 4.29729 12.9754C5.15547 13.8335 6.24886 14.418 7.43919 14.6547C8.62952 14.8915 9.86334 14.77 10.9846 14.3056C12.1059 13.8411 13.0642 13.0546 13.7385 12.0455C14.4128 11.0364 14.7727 9.84998 14.7727 8.63633C14.7726 7.0089 14.126 5.44817 12.9753 4.2974C11.8245 3.14664 10.2638 2.5001 8.63633 2.5Z"
                stroke="#AEA9B4"
                stroke-width="1.5"
                stroke-miterlimit="10"
              />
              <path
                d="M13.2148 13.2145L17.5004 17.5"
                stroke="#AEA9B4"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <input
            type="number"
            placeholder={t("homepage.trackorderPlaceHolder")}
            className="trackOrder"
            value={trackerOrderNo}
            onChange={(e) => settrackerOrder(e.target.value)}
          />

          <div className="btnContainer" onClick={trackOrderBtnClick}>
            <div className="trackOrderBtn">{t("homepage.Track & Trace")}</div>
          </div>
        </div>
        {trackerOrderData && (
          <div className="trackOrderList">
            <div className="orderStatusText">
              {t("Your order status :")} {trackerOrderData?.orderNumber}
            </div>

            <div className="trackingDataContainerLine"></div>
            <div className="d-f jc-sb ">
              <div className="d-f f-c">
                <div className="orderStatus">
                  {formatText(trackerOrderData?.status)}
                </div>
                <div className="OrderDateTxt">
                  Order date:
                  {moment(trackerOrderData?.createdAt).format("MMMM Do YYYY")}
                </div>
              </div>
              <div style={{ marginTop: "auto" }}>
                <div
                  onClick={() =>
                    props.history.push("TrackingDetails", trackerOrderNo)
                  }
                  className="viewMoreBtnClick"
                >
                  <div className="txt">View more</div>

                  <svg
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="vuesax/outline/location">
                      <g id="location">
                        <path
                          id="Vector"
                          d="M8.49906 10.0371C7.26561 10.0371 6.25781 9.03466 6.25781 7.79581C6.25781 6.55865 7.26392 5.56165 8.49906 5.56165C9.73251 5.56165 10.7403 6.56405 10.7403 7.8029C10.7403 9.04006 9.7342 10.0371 8.49906 10.0371ZM8.49906 5.62415C7.30346 5.62415 6.32031 6.59747 6.32031 7.8029C6.32031 9.00695 7.295 9.98165 8.49906 9.98165C9.70312 9.98165 10.6778 9.00695 10.6778 7.8029C10.6778 6.59747 9.69467 5.62415 8.49906 5.62415Z"
                          fill="#101828"
                          stroke="white"
                        />
                        <path
                          id="Vector_2"
                          d="M2.53376 6.51162L2.53389 6.51106C3.25618 3.32906 6.03028 1.88538 8.49921 1.88538H8.49921H8.49922H8.49922H8.49923H8.49923H8.49923H8.49924H8.49924H8.49925H8.49925H8.49925H8.49926H8.49926H8.49927H8.49927H8.49928H8.49928H8.49929H8.49929H8.49929H8.4993H8.4993H8.49931H8.49931H8.49932H8.49932H8.49933H8.49933H8.49934H8.49935H8.49935H8.49936H8.49936H8.49937H8.49938H8.49938H8.49939H8.4994H8.4994H8.49941H8.49941H8.49941H8.49942H8.49942H8.49943H8.49943H8.49943H8.49944H8.49944H8.49945H8.49945H8.49946H8.49946H8.49946H8.49947H8.49947H8.49948H8.49948H8.49949H8.49949H8.4995H8.4995H8.49951H8.49951H8.49952H8.49952H8.49953H8.49953H8.49954H8.49954H8.49955H8.49956H8.49956H8.49957H8.49957H8.49958H8.49958H8.49959H8.4996H8.4996H8.49961H8.49961H8.49962H8.49963H8.49963H8.49964H8.49964H8.49965H8.49966H8.49966H8.49967H8.49968H8.49968H8.49969H8.4997H8.49971H8.49971H8.49972H8.49973H8.49973H8.49974H8.49975H8.49976H8.49976H8.49977H8.49978H8.49979H8.49979H8.4998H8.49981H8.49982H8.49983H8.49984H8.49984H8.49985H8.49986H8.49987H8.49988H8.49989H8.49989H8.4999H8.49991H8.49992H8.49993H8.49994H8.49995H8.49996H8.49997H8.49998H8.49999H8.5H8.50001H8.50001H8.50002H8.50003H8.50004H8.50005H8.50006H8.50007H8.50008H8.5001H8.50011H8.50012H8.50013H8.50014H8.50015H8.50016H8.50017H8.50018H8.50019H8.5002H8.50021H8.50023H8.50024H8.50025H8.50026H8.50027H8.50028H8.5003H8.50031H8.50032H8.50033H8.50034H8.50036H8.50037H8.50038H8.50039H8.50041H8.50042H8.50043H8.50044H8.50046H8.50047H8.50048H8.5005H8.50051H8.50052H8.50054H8.50055H8.50056H8.50058H8.50059H8.50061H8.50062H8.50063H8.50065H8.50066H8.50068H8.50069H8.50071H8.50072H8.50074H8.50075H8.50077H8.50078H8.5008H8.50081H8.50083H8.50084H8.50086H8.50087H8.50089H8.50091H8.50092H8.50094H8.50096H8.50097H8.50099H8.501H8.50102H8.50104H8.50106H8.50107H8.50109H8.50111H8.50112H8.50114H8.50116H8.50118H8.50119H8.50121H8.50123H8.50125H8.50127H8.50128H8.5013H8.50132H8.50134H8.50136H8.50138H8.5014H8.50141H8.50143H8.50145H8.50147H8.50149H8.50151H8.50153H8.50155H8.50157H8.50159H8.50161H8.50163H8.50165H8.50167H8.50169H8.50171H8.50173H8.50176H8.50178H8.5018H8.50182H8.50184H8.50186H8.50188H8.5019H8.50193H8.50195H8.50197H8.50199H8.50202H8.50204H8.50206H8.50208H8.50211H8.50213H8.50215H8.50217H8.5022H8.50222H8.50224H8.50227H8.50229H8.50232H8.50234H8.50236H8.50239H8.50241H8.50244H8.50246H8.50249H8.50251H8.50254H8.50256H8.50259H8.50261H8.50264H8.50266H8.50269H8.50272H8.50274H8.50277H8.50279H8.50282H8.50285H8.50287H8.5029H8.50293H8.50295H8.50298H8.50301H8.50304H8.50306H8.50309H8.50312H8.50315H8.50318H8.5032H8.50323H8.50326H8.50329H8.50332H8.50335H8.50338H8.50341H8.50344H8.50346H8.50349H8.50352H8.50355H8.50358H8.50361H8.50364H8.50367H8.50371H8.50374H8.50377H8.5038H8.50383H8.50386H8.50389H8.50392H8.50396H8.50399H8.50402H8.50405H8.50408H8.50412H8.50415H8.50418H8.50421H8.50425H8.50428H8.50431H8.50435H8.50438H8.50441H8.50445H8.50448H8.50452H8.50455H8.50458H8.50462H8.50465H8.50469H8.50472H8.50476H8.50479H8.50483H8.50487H8.5049H8.50494H8.50497H8.50501H8.50505H8.50508H8.50512H8.50516H8.50519H8.50523H8.50527H8.50531H8.50534H8.50538H8.50542H8.50546H8.5055H8.50553H8.50557H8.50561H8.50565H8.50569H8.50573H8.50577H8.50581H8.50585H8.50589H8.50593H8.50597H8.50601H8.50605H8.50609H8.50613H8.50617H8.50621H8.50625H8.50629C10.9749 1.88538 13.7491 3.32872 14.4715 6.51784C15.2745 10.0655 13.1384 13.0946 11.0784 15.078C10.3519 15.7729 9.42137 16.1216 8.49921 16.1216C7.57708 16.1216 6.64656 15.7729 5.92008 15.078C3.86029 13.0949 1.72424 10.059 2.53376 6.51162ZM14.4128 6.52434L14.4124 6.52235C13.6352 3.13374 10.7092 1.94788 8.49921 1.94788C6.2889 1.94788 3.3698 3.13415 2.60007 6.5229C1.77229 10.1342 4.04911 13.1839 5.97094 15.027C7.38995 16.3961 9.61574 16.3961 11.0347 15.0269C12.9493 13.1839 15.2254 10.1348 14.4128 6.52434Z"
                          fill="#101828"
                          stroke="white"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>

      <section className="homesec3 wow fadeIn">
        <Row>
          <Col lg={16} md={12} sm={12}>
            <div className="firstContainer">
              <div className="title">{t("Get Quote")}</div>
              <div className="desc">{t("Get the best rates")}</div>

              <div className="whiteContainer">
                <div className="orderStatusText">{t("Add Pickup")}</div>

                <div className="LocationContainer">
                  <div className="d-f first ">
                    <input
                      ref={sourceInput}
                      type="text"
                      placeholder="Enter source location...."
                    />
                    <div className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M8.63633 2.5C7.42268 2.5 6.23628 2.85989 5.22717 3.53416C4.21806 4.20843 3.43155 5.16679 2.9671 6.28806C2.50266 7.40932 2.38114 8.64314 2.61791 9.83347C2.85468 11.0238 3.43911 12.1172 4.29729 12.9754C5.15547 13.8335 6.24886 14.418 7.43919 14.6547C8.62952 14.8915 9.86334 14.77 10.9846 14.3056C12.1059 13.8411 13.0642 13.0546 13.7385 12.0455C14.4128 11.0364 14.7727 9.84998 14.7727 8.63633C14.7726 7.0089 14.126 5.44817 12.9753 4.2974C11.8245 3.14664 10.2638 2.5001 8.63633 2.5Z"
                          stroke="#AEA9B4"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M13.2148 13.2145L17.5004 17.5"
                          stroke="#AEA9B4"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="d-f second ">
                    <input
                      type="text"
                      value={sourceAddress?.pincode}
                      onChange={(e) => {
                        const obj = { ...sourceAddress };
                        obj["pincode"] = e.target.value;
                        setSourceAddress(obj);
                      }}
                      placeholder="Pincode"
                    />
                  </div>
                </div>
                <div className="orderStatusText mt-3">
                  {t("Add Destination")}
                </div>

                <div className="LocationContainer">
                  <div className="d-f first ">
                    <input
                      ref={destInput}
                      type="text"
                      placeholder="Enter destination location...."
                    />
                    <div className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M8.63633 2.5C7.42268 2.5 6.23628 2.85989 5.22717 3.53416C4.21806 4.20843 3.43155 5.16679 2.9671 6.28806C2.50266 7.40932 2.38114 8.64314 2.61791 9.83347C2.85468 11.0238 3.43911 12.1172 4.29729 12.9754C5.15547 13.8335 6.24886 14.418 7.43919 14.6547C8.62952 14.8915 9.86334 14.77 10.9846 14.3056C12.1059 13.8411 13.0642 13.0546 13.7385 12.0455C14.4128 11.0364 14.7727 9.84998 14.7727 8.63633C14.7726 7.0089 14.126 5.44817 12.9753 4.2974C11.8245 3.14664 10.2638 2.5001 8.63633 2.5Z"
                          stroke="#AEA9B4"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M13.2148 13.2145L17.5004 17.5"
                          stroke="#AEA9B4"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="d-f second ">
                    <input
                      type="text"
                      value={destAddress?.pincode}
                      onChange={(e) => {
                        const obj = { ...destAddress };
                        obj["pincode"] = e.target.value;
                        setDestAddress(obj);
                      }}
                      placeholder="Pincode"
                    />
                  </div>
                </div>

                <div className="orderStatusText mt-3">{t("Add Weight")}</div>

                <div className="WeightContainer">
                  <input
                    type="number"
                    placeholder="Enter weight"
                    value={weight}
                    onChange={handleWeightChange}
                  />
                  <select value={unit} onChange={handleUnitChange}>
                    <option value="kg">kg</option>
                    <option value="lbs">lbs</option>
                  </select>
                </div>

                <div className="btnContainer">
                  <Button
                    onClick={handleGetRateBtnClick}
                    orange="orange"
                    title={t("Get Rates")}
                  />
                </div>
              </div>
            </div>
          </Col>
          <Col lg={8} md={12} sm={12}>
            <div className="secondContainer">
              <div className="title">Place Shipment</div>
              <div className="desc">Book your shipment instantly</div>

              <div className="imgContainer">
                <img src={packageDelivery} className="fluid" />
              </div>
              <div className="btnContainer">
                <Button onClick={handleBookNowBtnClick} title="Book Now" />
              </div>
            </div>
          </Col>
        </Row>
      </section>

      {orderData && (
        <section className="homepage_sec3 wow fadeIn d-f j-c a-c f-c">
          <div className="title">Your Rates</div>
          <table class="orderList">
            <tr>
              <th>CSP</th>
              <th>Transit days</th>
              <th>Cost</th>
              <th>Action</th>
            </tr>
            {orderData?.map((item, i) => {
              const totalCharge = item?.totalPricing?.toFixed(2);
              return (
                <tr key={i}>
                  <td>{item?.serviceName}</td>
                  <td>{item?.transitTime}</td>
                  <td>
                    {/* {totalCharge}.{item?.currency?.symbol} */}
                    {totalCharge}
                  </td>
                  <td>
                    <div
                      onClick={handleBookNowBtnClick}
                      className="viewMoreBtnClick"
                    >
                      <div className="txt">Ship Now</div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </table>
        </section>
      )}

      <section className="homepage_sec8 wow fadeIn d-f j-c a-c f-c ">
        <div className="container">
          <div className="title">{t("homepage.sec8title")}</div>
          {ratingList?.length ? (
            <>
              {width >= 1024 ? (
                <>
                  <div className="testinomials-content  p-r ">
                    <div className="homepage_sec8-swiper swiper-container">
                      <div className="swiper-wrapper">{reviewSlider}</div>
                    </div>

                    <div className="d-f j-c " style={{ paddingTop: "2em" }}>
                      <div className="swiper-pagination"></div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="testinomials-content  p-r ">
                    <div className="homepage_sec8-swiper swiper-container">
                      <div className="swiper-wrapper">{reviewSlider}</div>
                    </div>

                    <div className="d-f j-c " style={{ paddingTop: "2em" }}>
                      <div className="swiper-pagination"></div>
                    </div>
                  </div>
                </>
              )}
            </>
          ) : null}

          <div className="btnContainer">
            <Button
              ogFull="orange"
              onClick={() => setShow(true)}
              title="Write a review"
            />
          </div>
        </div>

        <Modal
          {...props}
          //   size="lg"
          //   aria-labelledby="contained-modal-title-vcenter"
          className="ratingModel"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <h3>Write a review </h3>
          </Modal.Header>
          <Modal.Body className="model">
            <Row className="ratingModelrow">
              <Col lg={24}>
                <InputText
                  value={reviewName}
                  onChange={(e) => setName(e.target.value)}
                  title="Name"
                />
              </Col>
              <Col lg={24}>
                <InputText
                  dropdown
                  onChange={handleOnChangeRating}
                  defaultValue={5}
                  list={[
                    { name: "1", value: 1 },
                    { name: "2", value: 2 },
                    { name: "3", value: 3 },
                    { name: "4", value: 4 },
                    { name: "5", value: 5 },
                  ]}
                />
              </Col>
              <Col lg={24}>
                <InputText
                  value={feedbackTxt}
                  onChange={(e) => setFeedbackText(e.target.value)}
                  title="Feedback*"
                />
                <div style={{ paddingTop: "1em" }} className="err">
                  {feedbackErr}
                </div>
              </Col>
            </Row>
            <br></br>
            <div className="btnContainer d-f j-c  mt-4">
              <Button onClick={handleReviewBtnClick} title="SUBMIT" />
            </div>
          </Modal.Body>
        </Modal>
      </section>

      <section className="homepage_sec5 wow fadeIn d-f j-c a-c f-c">
        {/* <div className='span'>
					<img className='fluid' src={create1} />&nbsp;Why Choose Us
				</div> */}
        {/* <div className='title'>{t('homepage.sec5title')} </div> */}
        {/* <div className='desc'>{t('homepage.sec5desc')}</div> */}

        <Row>
          <Col lg={24}>
            <div className="leftcontainer">
              <img src={whyUsBanner} className="fluid" />
            </div>
          </Col>
          {/* <Col lg={12}>
						<div className='rightcontainer'>
							<div className='listContainer'>
								<div className='d-f'>
									<div className='imgContainer'>
										<img className='logo fluid' src={blueTick} />
									</div>
									<div className='desc1'>
										<div className='t1'>{t('homepage.Customer Support')}</div>
										<div className='t2'>{t('homepage.sec5t2')}</div>
									</div>
								</div>
								<div className='d-f mt'>
									<div className='imgContainer'>
										<img className='logo fluid' src={blueTick} />
									</div>

									<div className='desc1'>
										<div className='t1'>{t('homepage.sc5t3')}</div>
										<div className='t2'>{t('homepage.sec5t4')}</div>
									</div>
								</div>
								<div className='d-f mt'>
									<div className='imgContainer'>
										<img className='logo fluid' src={blueTick} />
									</div>
									<div className='desc1'>
										<div className='t1'>{t('homepage.sc5t5')}</div>
										<div className='t2'>{t('homepage.sc5t6')}</div>
									</div>
								</div>
							</div>
						</div>
					</Col> */}
        </Row>
      </section>

      <section className="homepage_sec6 wow fadeIn d-f j-c a-c">
        <div className="flexcontainer d-f a-c j-c">
          <div
            onClick={() => props.history.push("/dispute-center")}
            className="imgcontainer d-f "
          >
            <div>
              <img className="strength fluid" src={dispute} />
            </div>
            <div className="text">{t("Feedback Centre")}</div>
          </div>
          <div
            onClick={() => props.history.push("/careers")}
            className="imgcontainer d-f"
          >
            <div>
              <img className="strength fluid" src={career} />
            </div>
            <div className="text">{t("Career Centre")} </div>
          </div>
          <div
            onClick={() => props.history.push("/transit")}
            className="imgcontainer d-f"
          >
            <div>
              <img className="strength fluid" src={transit} />
            </div>
            <div className="text">{t("transit.title")}</div>
          </div>
          <div
            onClick={() => props.history.push("/business")}
            className="imgcontainer d-f"
          >
            <div>
              <img className="small fluid" src={business} />
            </div>
            <div className="text">{t("WYNGS’s for Business")}</div>
          </div>
          <div
            onClick={() => props.history.push("/ecommercePlatform")}
            className="imgcontainer d-f"
          >
            <div>
              <img className="small fluid" src={integration} />
            </div>
            <div className="text">
              {t("Integration with Ecommerce Platforms")}
            </div>
          </div>
          <div
            onClick={() => props.history.push("/program")}
            className="imgcontainer d-f"
          >
            <div>
              <img className="small fluid" src={program} />
            </div>

            <div className="text">{t("Programs")}</div>
          </div>
        </div>
      </section>
      <section className="homepage_sec4 wow fadeIn d-f j-c a-c ">
        <div className="d-f f-c j-c a-c ">
          <div className="GbtitleContainer">
            <div>
              <img className="fluid" src={create} />
            </div>
            <div className="txt">{t("homepage.Connections")}</div>
          </div>

          <div className="title">{t("homepage.sec4Title")} </div>

          <div className="boxcontainer d-f f-r a-c j-c">
            <div
              onClick={() =>
                (window.location.href =
                  "https://www.facebook.com/WYNGSMALAYSIA")
              }
              className="box c-p"
            >
              <div className="imgWrapper">
                <img className=" fluid" src={fbscan} />
              </div>
              <div className="card-title">Facebook</div>
            </div>
            <div
              onClick={() =>
                (window.location.href = "https://me-qr.com/9zJ40pVd")
              }
              className="box c-p"
            >
              <div className="imgWrapper">
                <img className=" fluid" src={youtubescan} />
              </div>
              <div className="card-title">Youtube</div>
            </div>
            <div
              className="box c-p"
              onClick={() =>
                (window.location.href = "https://me-qr.com/re9utMtj")
              }
            >
              <div className="imgWrapper">
                <img className=" fluid" src={whatsappscan} />
              </div>
              <div className="card-title">Whatsapp</div>
            </div>
          </div>
        </div>
        {/* {width > 1024 ? (
					<div style={{ paddingLeft: '5em' }}>
						<div className='title'>{t('homepage.Social Media')}</div>

						<div className='imageContainer d-f'>
							<iframe
								src='https://www.facebook.com/plugins/page.php?href=WYNGSMALAYSIA&tabs=timeline&width=340&height=300&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId'
								width='350px'
								height='350px'
								style={{ border: 'none', overflow: 'hidden' }}
								scrolling='no'
								frameborder='0'
								allowfullscreen='true'
								allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'
							></iframe>
						</div>
					</div>
				) : null} */}
      </section>

      {/* {width < 1024 ? (
				<section className='homepage_sec7 wow fadeIn d-f j-c a-c f-c'>
					<div className='title'>{t('homepage.Social Media')}</div>

					<div className='imageContainer d-f'>
						<iframe
							src='https://www.facebook.com/plugins/page.php?href=WYNGSMALAYSIA&tabs=timeline&width=340&height=300&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId'
							width='400'
							height='350px'
							style={{ border: 'none', overflow: 'hidden' }}
							scrolling='no'
							frameborder='0'
							allowfullscreen='true'
							allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'
						></iframe>
					</div>
				</section>
			) : null} */}

      <FooterContactUsItem
        title={t("For Bussiness")}
        btnTxt="Contact me"
        color="blue"
      />
    </div>
  );
};

export default Homepage;
